// TODO(#60): Replace with real cover photo asset (clinical trial imagery — e.g. lab, data flow, patient journey)
const CoverPhoto = () => (
  <div
    aria-hidden="true"
    style={{
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(135deg, #0972d3 0%, #033160 100%)",
      color: "#ffffff",
      padding: "40px",
      textAlign: "center",
    }}
  >
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="60" cy="60" r="56" stroke="#ffffff" strokeWidth="2" opacity="0.3" />
      <circle cx="60" cy="60" r="40" stroke="#ffffff" strokeWidth="2" opacity="0.2" />
      <path
        d="M40 60 L55 75 L80 45"
        stroke="#ffffff"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    <p
      style={{
        marginTop: "24px",
        fontSize: "24px",
        fontWeight: 600,
        lineHeight: 1.3,
        maxWidth: "320px",
      }}
    >
      Streamlining Clinical Data Transfers
    </p>
    <p style={{ marginTop: "12px", fontSize: "14px", opacity: 0.7 }}>
      Secure. Compliant. Automated.
    </p>
  </div>
)

export default CoverPhoto
